export const resetDateSeconds = (date: Date) => {
  date.setSeconds(0, 0);
  return date;
};
